import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';
import { getPurchaseRequisition } from '../../common/endpoints';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const fetchPurchaseRequisition = createApi(
  getPurchaseRequisition,
  'GET'
);

const purchaseRequisitionSlice = createSlice({
  name: 'purchaseRequisition',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPurchaseRequisition.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPurchaseRequisition.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchPurchaseRequisition.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default purchaseRequisitionSlice.reducer;
